import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Newfooter from "../NewFooter/Newfooter";
import Newheader from "../NewHeader/Newheader";
import WarningIconImg from "../../images/warning1.jpg"; 

import { 
  VIPSDataServiceURL, 
  requestOptions, 
  AppURL, 
  PrivacyNotes, 
  RequiredField, 
  ORDERING_PATH
} from '../../Constants/GlobalConstant';

import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  Paper,
  Link as MuiLink,
  Alert,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Divider,
  Fade,
  Collapse,
  CircularProgress,
  Zoom,
  Slide
} from "@mui/material";

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import Gavel from '@mui/icons-material/Gavel';
import LoginIcon from '@mui/icons-material/Login';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const CONFIG = {
  ORDERING_PATH_PREFIX: ORDERING_PATH,
  BASE_URL: VIPSDataServiceURL.replace(/\/$/, ""),   
   
  KEYS: {
    COOKIE_CONSENT: "VIPS_CookieConsent",
    SESSION: "VIPS_Session",
    REMEMBER_USER: "VIPS_RememberUser"
  },

  TIMEOUTS: {
    REDIRECT: 1500
  },

  ENDPOINTS: {
    CUSTOM_MSG: '/User/GetCustomMessage', 
    LOGIN: '/User/Login'
  },

  COLORS: {
    PRIMARY: '#007bff',
    PRIMARY_DARK: '#0056b3',
    ERROR: '#d32f2f',       
    ERROR_BG: '#fff4f4',    
    ERROR_BORDER: '#ffcdd2',
    TEXT_DARK: '#333',
    TEXT_LIGHT: '#666',
    BG_MAIN: '#f0f2f5',
    BG_COOKIE: '#990000',
    BTN_COOKIE: '#ff0000',
    SUCCESS: '#2e7d32'
  }
};

const TEXTS = {
    title: "VIPS Login",
    welcomeTitle: "Welcome to",
    brandName: "Avery Dennison",
    portalName: "VIPS Portal",
    instruction: "Please sign in to access your ordering dashboard.",
    logonLabel: "Logon Name",
    passLabel: "Password",
    btnNext: "Next",
    btnBack: "Back",
    btnLogin: "Log In",
    loggingIn: "Logging In...",
    remember: "Remember me",
    forgot: "Forgot password?",
    newUser: "New User?",
    register: "Click here to register",
    errorHeader: "Authentication Issue",
    signingInAs: "Signing in as:",
    required: RequiredField, 
    termsTitle: "Terms of Service",
    termsAgree: "I Agree",
    termsDisagree: "I Disagree",
    termsContent: "These Terms of Service are issued by Avery Dennison and govern your use of the Avery Dennison website. Please read them carefully as they affect your rights and liabilities under the law. If you do not agree to these Terms and Conditions, please do not register for or use the Avery Dennison website.",
    welcomeAboard: "Welcome Aboard",
    agreementAccepted: "Agreement accepted successfully.",
    cookieText: "This site uses cookies as described in our Cookie Policy. To see what cookies we serve and set your own preferences, please use our Cookie Consent Tool. Otherwise, if you agree to our use of cookies, please continue to use our site",
    cookieBtn: "GOT IT!", 
    cookieLink: "Learn More",
    cookieLinkUrl: PrivacyNotes,
    errLocked: "Your account is currently locked. Please contact support.",
    errAccessDenied: "Access Denied: Invalid Credentials.",
    errBadRequest: "Error 400: Bad Request.",
    errNotFound: "Error 404: Endpoint not found.",
    errNetwork: "Network Error: Unable to reach the VIPS Data Service.",
    apologyMsgEn: "Our login service is currently unavailable. We apologize for the inconvenience. Please try again later.",
    apologyMsgCh: "我们的登录服务目前不可用。对于给您带来的不便，我们深表歉意。请稍后再试。"
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Fade ref={ref} {...props} />;
});

const Login = () => {
    
  const [showPassword, setShowPassword] = useState(false);
  const [customMessages, setCustomMessages] = useState([]);
  const [formStatus, setFormStatus] = useState({ type: '', msg: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSSOProcessing, setIsSSOProcessing] = useState(false);
  const [isApiLive, setIsApiLive] = useState(true); // Tracking API health
  const [step, setStep] = useState(1);
   
  const t = TEXTS;
  const [showCookieBanner, setShowCookieBanner] = useState(false);
  const [formData, setFormData] = useState({ userId: '', password: '' });
  const [rememberMe, setRememberMe] = useState(false);
  const [openTerms, setOpenTerms] = useState(false);
  const [openThanks, setOpenThanks] = useState(false);

  // --- HANDLE SSO LOGIN (Untouched) ---
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    
    const ssoToken = searchParams.get("token") || searchParams.get("ssoToken");

    if (ssoToken) {
        setIsSSOProcessing(true);
        performSSOLogin(ssoToken);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const performSSOLogin = async (tokenValue) => {
    setIsSSOProcessing(true);
    setStatus('', '');

    try {
        // We construct the query string manually to match your Postman success exactly
        // userId=""&password=""&ssoToken=TOKEN
        const queryParams = `userId=""&password=""&ssoToken=${tokenValue}`;
        const fullUrl = `${CONFIG.BASE_URL}${CONFIG.ENDPOINTS.LOGIN}?${queryParams}`;

        const response = await axios.post(fullUrl, null, { 
            headers: requestOptions.headers 
        });

        // Your API returns userId: "\"\"" on success, so we handle that
        handleLoginResponse(response.data, false);

    } catch (error) {
        console.error("SSO Exception:", error);
        setIsSSOProcessing(false);
        handleLoginError(error);
    }
  };

  useEffect(() => {
    const cookieConsent = localStorage.getItem(CONFIG.KEYS.COOKIE_CONSENT);
    if (!cookieConsent) {
        setShowCookieBanner(true);
    }

    const savedUser = localStorage.getItem(CONFIG.KEYS.REMEMBER_USER);
    if (savedUser) {
        setFormData(prev => ({ ...prev, userId: savedUser }));
        setRememberMe(true);
    }

    const fetchCustomMessage = async () => {
      try {
        const queryParams = new URLSearchParams({ userId: '""' }).toString();
        const fullUrl = `${CONFIG.BASE_URL}${CONFIG.ENDPOINTS.CUSTOM_MSG}?${queryParams}`;
          
        const response = await axios.post(fullUrl, null, { headers: requestOptions.headers });
        const data = response.data;
        
        setIsApiLive(true); // Successfully reached API
          
        if (Array.isArray(data) && data.length > 0) {
            let rawHtml = data[0];
            const parts = rawHtml.split(/<br\s*\/?>/i);
            const cleanedParts = parts.map(part => {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = part;
                return (tempDiv.textContent || tempDiv.innerText || "").trim();
            }).filter(text => text.length > 0);

            setCustomMessages(cleanedParts);
        }
      } catch (err) {
        console.warn("Custom Message Failed:", err);
        setIsApiLive(false); // Trigger apology view on failure
      }
    };
    fetchCustomMessage();
  }, []);

  const setStatus = (type, msg) => setFormStatus({ type, msg });

  const handleCookieAccept = () => {
      localStorage.setItem(CONFIG.KEYS.COOKIE_CONSENT, "true");
      setShowCookieBanner(false);
  };

  const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleRememberMeChange = (e) => {
      setRememberMe(e.target.checked);
  };

  const handleBackStep = () => {
    setStep(1);
    setStatus('', '');
  };

  const handleLoginResponse = (data, shouldRemember) => {
      const responseMsg = (data.message || "").toLowerCase();

      if (responseMsg.includes("locked")) {
          setStatus('error', data.message || t.errLocked);
          setIsSubmitting(false);
          // If this was an SSO attempt, we must reveal the form now
          setIsSSOProcessing(false);
          return; 
      }

      const hasSession = data && (data.sessionId || data.SessionID);
      const isValidUser = data && data.userValid === true;

      if (hasSession && isValidUser) {
        const session = data.sessionId || data.SessionID;
        localStorage.setItem(CONFIG.KEYS.SESSION, session);

        if (shouldRemember) {
            localStorage.setItem(CONFIG.KEYS.REMEMBER_USER, formData.userId);
        } else {
            localStorage.removeItem(CONFIG.KEYS.REMEMBER_USER);
        }

        const incomingLastUrl = (data.lastURL || data.LastURL || data.redirectUrl || "").trim();
        const legacyDomain = AppURL;

        if (incomingLastUrl && incomingLastUrl !== "") {
            if (incomingLastUrl.startsWith("/") && !incomingLastUrl.toLowerCase().startsWith("http")) {
                window.location.href = `${legacyDomain}${incomingLastUrl}`;
            } else {
                window.location.href = incomingLastUrl;
            }
        } else {
             window.location.href = `${legacyDomain}/${ORDERING_PATH}/Home?session_id=${session}`; 
        }

      } else {
        setStatus('error', data.message || t.errAccessDenied);
        setIsSubmitting(false);
        setIsSSOProcessing(false); // Reveal form on error
      }
  };

  const handleLoginError = (error) => {
      if (error.response) {
         const status = error.response.status;
         if (status === 400) setStatus('error', t.errBadRequest);
         else if (status === 404) setStatus('error', t.errNotFound);
         else setStatus('error', error.response.data?.message || `Login Failed (${status})`);
      } else {
        setStatus('error', t.errNetwork);
      }
  };

  // --- Single Form Submit Handler ---
  const onSubmit = async (e) => {
    e.preventDefault();

    // Step 1: Move to password (Browser already validated "required")
    if (step === 1) {
        setStatus('', ''); 
        setStep(2);
        return;
    }

    // Step 2: Perform login (Browser already validated "required")
    setIsSubmitting(true);
    setStatus('', '');

    try {
      const queryParams = new URLSearchParams({
        userId: formData.userId,
        password: formData.password, 
        ssoToken: "" 
      }).toString();

      const fullUrl = `${CONFIG.BASE_URL}${CONFIG.ENDPOINTS.LOGIN}?${queryParams}`;
      const response = await axios.post(fullUrl, null, { headers: requestOptions.headers });
      handleLoginResponse(response.data, rememberMe);

    } catch (error) {
      setIsSubmitting(false);
      handleLoginError(error);
    }
  };

  const handleOpenTerms = () => setOpenTerms(true);
  const handleDisagree = () => setOpenTerms(false);
  const handleAgree = () => {
    setOpenTerms(false);
    setOpenThanks(true);
    const registerPath = `/${CONFIG.ORDERING_PATH_PREFIX}/register`;
    setTimeout(() => {
      setOpenThanks(false);
      window.location.href = registerPath; 
    }, CONFIG.TIMEOUTS.REDIRECT);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: CONFIG.COLORS.BG_MAIN }}>
      <Newheader />

      <Box component="main" sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', pt: 4, pb: 8 }}>
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center" justifyContent="center">
              
            <Grid item xs={12} md={6}>
              <Box sx={{ pr: { md: 4 }, textAlign: { xs: 'center', md: 'left' }, mb: { xs: 4, md: 0 } }}>
                <Typography variant="h3" sx={{ fontWeight: "bold", color: CONFIG.COLORS.TEXT_DARK, lineHeight: 1.3, fontSize: { xs: '2rem', md: '3rem' } }}>
                  {t.welcomeTitle} <br />
                  <span style={{ whiteSpace: "nowrap", color: CONFIG.COLORS.ERROR }}>{t.brandName}</span>{" "}
                  <span style={{ whiteSpace: "nowrap" }}>{t.portalName}</span>
                </Typography>
                <Typography variant="h6" sx={{ mt: 2, color: CONFIG.COLORS.TEXT_LIGHT, fontWeight: 'normal' }}>
                  {t.instruction}
                </Typography>
              </Box>
            </Grid>

            {/* RIGHT SIDE: Login Form */}
            <Grid item xs={12} md={6}>
              <Paper 
                elevation={6} 
                sx={{ 
                    position: 'relative',
                    p: { xs: 3, md: 5 }, 
                    borderRadius: 4, 
                    width: "100%", 
                    maxWidth: "450px", 
                    mx: 'auto',
                    overflow: 'hidden'
                }}
              >
                  
                <Box sx={{ mb: 4, mt: 1, textAlign: 'center' }}>
                  <Typography variant="h4" sx={{ fontWeight: 800, letterSpacing: '-0.5px', color: '#222' }}>
                    {t.title}
                  </Typography>
                  <Box sx={{ width: '60px', height: '4px', backgroundColor: CONFIG.COLORS.ERROR, mx: 'auto', mt: 1, borderRadius: 2 }} />
                  
                  {/* --- APOLOGY/CUSTOM MESSAGE CONTAINER --- */}
                  {((!isApiLive) || (isApiLive && customMessages.length > 0 && !isSSOProcessing)) && (
                    <Box sx={{ mt: 3, p: 1.5, bgcolor: CONFIG.COLORS.ERROR_BG, borderRadius: 2, border: `1px dashed ${CONFIG.COLORS.ERROR_BORDER}` }}>
                        {!isApiLive ? (
                            /* Apology logic when API fails */
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, textAlign: 'left' }}>
                                    <Box component="img" src={WarningIconImg} alt="Warning" sx={{ width: 20, height: 20, mt: 0.3, flexShrink: 0, objectFit: 'contain' }} />
                                    <Typography variant="body2" sx={{ lineHeight: 1.5, fontWeight: 700, color: CONFIG.COLORS.ERROR }}>{t.apologyMsgEn}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, textAlign: 'left' }}>
                                    <Box component="img" src={WarningIconImg} alt="Warning" sx={{ width: 20, height: 20, mt: 0.3, flexShrink: 0, objectFit: 'contain' }} />
                                    <Typography variant="body2" sx={{ lineHeight: 1.5, fontWeight: 500, color: CONFIG.COLORS.ERROR }}>{t.apologyMsgCh}</Typography>
                                </Box>
                            </Box>
                        ) : (
                            /* Original logic for Custom Messages when API is live */
                            customMessages.map((msg, index) => (
                               <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mb: index < customMessages.length - 1 ? 1 : 0, textAlign: 'left' }}>
                                   <Box component="img" src={WarningIconImg} alt="Warning" sx={{ width: 20, height: 20, mt: 0.3, flexShrink: 0, objectFit: 'contain' }} />
                                   <Typography variant="body2" sx={{ lineHeight: 1.5, fontWeight: 500, color: CONFIG.COLORS.ERROR }}>{msg}</Typography>
                               </Box>
                            ))
                        )}
                    </Box>
                  )}
                </Box>

                {/* --- FORM SECTION: HIDDEN IF API IS NOT LIVE --- */}
                {isApiLive && (
                  <>
                    <Collapse in={!!formStatus.msg}>
                      <Alert 
                        severity="error" 
                        icon={<ErrorOutlineIcon fontSize="inherit" />}
                        sx={{ mb: 3, borderRadius: 2, backgroundColor: CONFIG.COLORS.ERROR_BG, color: CONFIG.COLORS.ERROR, border: `1px solid ${CONFIG.COLORS.ERROR_BORDER}`, '& .MuiAlert-icon': { color: CONFIG.COLORS.ERROR } }} 
                        onClose={() => setStatus('', '')}
                      >
                        <strong>{t.errorHeader}</strong> — {formStatus.msg}
                      </Alert>
                    </Collapse>

                    {isSSOProcessing ? (
                       <Box sx={{ textAlign: 'center', py: 4 }}>
                          <CircularProgress size={50} sx={{ color: CONFIG.COLORS.PRIMARY, mb: 3 }} />
                          <Typography variant="h6" sx={{ fontWeight: 600, color: CONFIG.COLORS.TEXT_DARK }}>
                            Authenticating...
                          </Typography>
                          <Typography variant="body2" sx={{ mt: 1, color: CONFIG.COLORS.TEXT_LIGHT }}>
                            Please wait while we validate your credentials.
                          </Typography>
                       </Box>
                    ) : (
                        <form onSubmit={onSubmit}>
                          <Grid container spacing={2}>
                            
                            {step === 1 && (
                                <Zoom in={step === 1}>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle2" fontWeight={600} sx={{ color: CONFIG.COLORS.TEXT_DARK, mb: 0.5 }}>
                                            {t.logonLabel}<span style={{ color: CONFIG.COLORS.ERROR }}>*</span>
                                        </Typography>
                                        <TextField
                                            required
                                            name="userId"
                                            value={formData.userId}
                                            onChange={handleChange}
                                            fullWidth
                                            autoFocus
                                            size="medium"
                                            placeholder={t.logonLabel}
                                            autoComplete="username"
                                            InputProps={{ sx: { borderRadius: 1.5 } }}
                                        />
                                        <Button 
                                            type="submit"
                                            fullWidth 
                                            variant="contained" 
                                            endIcon={<ArrowForwardIcon />}
                                            sx={{ mt: 3, py: 1.5, fontSize: '16px', borderRadius: 2, bgcolor: CONFIG.COLORS.PRIMARY }}
                                        >
                                            {t.btnNext}
                                        </Button>
                                    </Grid>
                                </Zoom>
                            )}

                            {step === 2 && (
                                <Zoom in={step === 2}>
                                    <Grid item xs={12}>
                                        <input type="text" name="userId" defaultValue={formData.userId} autoComplete="username" style={{ display: 'none' }} readOnly />

                                        <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5', p: 1, borderRadius: 2 }}>
                                            <Typography variant="body2" color="textSecondary">
                                                {t.signingInAs} <strong>{formData.userId}</strong>
                                            </Typography>
                                            <IconButton size="small" onClick={handleBackStep} sx={{ ml: 1 }}>
                                                <ArrowBackIcon fontSize="small" />
                                            </IconButton>
                                        </Box>

                                        <Typography variant="subtitle2" fontWeight={600} sx={{ color: CONFIG.COLORS.TEXT_DARK, mb: 0.5 }}>
                                            {t.passLabel}<span style={{ color: CONFIG.COLORS.ERROR }}>*</span>
                                        </Typography>
                                        <TextField
                                            required
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            fullWidth
                                            autoFocus
                                            size="medium"
                                            type={showPassword ? "text" : "password"}
                                            placeholder={t.passLabel}
                                            autoComplete="current-password"
                                            InputProps={{
                                                sx: { borderRadius: 1.5 },
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                        
                                        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                                            <FormControlLabel 
                                                control={<Checkbox size="small" checked={rememberMe} onChange={handleRememberMeChange} />} 
                                                label={<Typography variant="body2">{t.remember}</Typography>} 
                                            />
                                            <MuiLink component={Link} to={`/${CONFIG.ORDERING_PATH_PREFIX}/forgotpassword`} underline="hover" variant="body2" sx={{ color: CONFIG.COLORS.PRIMARY, fontWeight: 500 }}>
                                                {t.forgot}
                                            </MuiLink>
                                        </Box>

                                        <Button 
                                            type="submit" 
                                            variant="contained" 
                                            fullWidth 
                                            disabled={isSubmitting}
                                            startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : <LoginIcon />}
                                            sx={{ mt: 3, py: 1.5, fontSize: "16px", fontWeight: 'bold', borderRadius: 2, bgcolor: CONFIG.COLORS.PRIMARY }}
                                        >
                                            {isSubmitting ? t.loggingIn : t.btnLogin}
                                        </Button>
                                        
                                        <Button fullWidth onClick={handleBackStep} sx={{ mt: 1, color: '#777' }}>
                                            {t.btnBack}
                                        </Button>
                                    </Grid>
                                </Zoom>
                            )}
                          </Grid>
                        </form>
                    )}

                    {!isSSOProcessing && (
                        <Box mt={3} textAlign="center">
                          <Typography variant="body2" color="textSecondary">
                            {t.newUser} {' '}
                            <MuiLink component="button" type="button" onClick={handleOpenTerms} underline="hover" sx={{ color: CONFIG.COLORS.PRIMARY, fontWeight: 'bold', cursor: 'pointer' }}>
                                {t.register}
                            </MuiLink>
                          </Typography>
                        </Box>
                    )}
                  </>
                )}
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* --- COOKIE BANNER AND DIALOGS (UNCHANGED) --- */}
      <Slide direction="up" in={showCookieBanner} mountOnEnter unmountOnExit>
        <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1300, bgcolor: CONFIG.COLORS.BG_COOKIE, color: '#fff', p: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, boxShadow: 3 }} square elevation={10}>
            <Typography variant="body2" sx={{ textAlign: 'center' }}>
                {t.cookieText} <MuiLink href={t.cookieLinkUrl} target="_blank" sx={{ color: '#fff', textDecoration: 'underline', ml: 1, fontWeight: 'bold' }}>{t.cookieLink}</MuiLink>
            </Typography>
            <Button variant="contained" size="small" onClick={handleCookieAccept} sx={{ bgcolor: CONFIG.COLORS.BTN_COOKIE, color: '#fff', fontWeight: 'bold', whiteSpace: 'nowrap', '&:hover': { bgcolor: CONFIG.COLORS.ERROR } }}>{t.cookieBtn}</Button>
        </Paper>
      </Slide>

      <Dialog open={openTerms} onClose={handleDisagree} TransitionComponent={Transition} maxWidth="sm" PaperProps={{ sx: { borderRadius: 3, borderTop: `8px solid ${CONFIG.COLORS.ERROR}` } }}>
        <DialogTitle sx={{ pt: 4, pb: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
            <Gavel sx={{ color: CONFIG.COLORS.ERROR, fontSize: 28 }} />
            <Typography variant="h5" sx={{ fontFamily: 'Georgia, serif', fontWeight: 'bold', color: CONFIG.COLORS.TEXT_DARK }}>{t.termsTitle}</Typography>
        </DialogTitle>
        <Divider sx={{ mx: 3, opacity: 0.6 }} />
        <DialogContent sx={{ py: 3, px: 4 }}>
            <DialogContentText sx={{ color: '#555', fontSize: '1.05rem', lineHeight: 1.6 }}>{t.termsContent}</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 1, justifyContent: 'space-between', bgcolor: '#fafafa' }}>
            <Button onClick={handleDisagree} variant="outlined" color="inherit">{t.termsDisagree}</Button>
            <Button onClick={handleAgree} variant="contained" sx={{ backgroundColor: '#212121', color: '#fff' }}>{t.termsAgree}</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openThanks} PaperProps={{ sx: { borderRadius: 4, p: 2, minWidth: '320px', borderTop: `6px solid ${CONFIG.COLORS.SUCCESS}` } }}>
        <Box sx={{ p: 4, textAlign: 'center' }}>
            <CheckCircleOutline sx={{ fontSize: 50, color: CONFIG.COLORS.SUCCESS, mb: 2 }} />
            <Typography variant="h5" fontWeight="bold">{t.welcomeAboard}</Typography>
            <Typography variant="body1" color="textSecondary">{t.agreementAccepted}</Typography>
        </Box>
      </Dialog>
        
      <Newfooter />
    </Box>
  );
};

export default Login;